import { FetchPotentialWarnings } from "./fetch_potential_warnings";

export type QueryKeyParams = {
  bookingsData: FetchPotentialWarnings["values"]["bookings"];
  activityId: number | undefined;
  workforceMemberId: number | undefined;
  bookingType: string;
  globalCategoryId: number | undefined;
  globalOverridesDiaryTime: boolean | undefined;
  globalOverridesNonWorkingTime: boolean | undefined;
};

export const potentialWarningsKeys = {
  all: () => ["potentialWarnings"],
  single: (params: QueryKeyParams) => [...potentialWarningsKeys.all(), params]
};
